import React from 'react'
import { User, Briefcase, ShieldCheck } from 'lucide-react'
import { useAppTheme, Text, Link } from '@workwhile/ui'
import * as ROUTES from 'constants/routes'
import { AccordionCard } from 'components/AccordionCard'
import { FlexibleInfoTable } from './FlexibleInfoTable'
import { useAssessmentDetailContextValue } from '../context/AssessmentDetailProvider'

export const GeneralDetails = () => {
  const { space } = useAppTheme()
  const {
    state: { workerName, workerId, positionName, positionId, requirements },
  } = useAssessmentDetailContextValue()

  return (
    <AccordionCard
      title="General details"
      size="small"
      contentWrapperProps={{
        display: 'flex',
        flexDirection: 'column',
        gap: space[2],
      }}
    >
      <FlexibleInfoTable Icon={User}>
        <Text fontSize={2}>
          {workerName} (
          <Link
            to={ROUTES.USER_DETAIL.replace(':userId', workerId.toString())}
            target="_blank"
          >
            {workerId}
          </Link>
          )
        </Text>
      </FlexibleInfoTable>
      <FlexibleInfoTable Icon={Briefcase}>
        <Text fontSize={2}>
          {positionName} (
          <Link
            to={ROUTES.POSITION_DETAIL.replace(
              ':positionId',
              positionId.toString()
            )}
            target="_blank"
          >
            {positionId}
          </Link>
          )
        </Text>
      </FlexibleInfoTable>
      <FlexibleInfoTable Icon={ShieldCheck}>
        {requirements.map((requirement) => (
          <Text key={requirement.id} fontSize={2}>
            {requirement.name} (
            <Link
              to={ROUTES.REQUIREMENT_DETAIL.replace(
                ':requirementId',
                requirement.id.toString()
              )}
              target="_blank"
            >
              {requirement.id}
            </Link>
            )
          </Text>
        ))}
      </FlexibleInfoTable>
    </AccordionCard>
  )
}
